<div *ngIf="showLoader" class="loader-container">
    <app-loader [showLoader]="true"></app-loader>
</div>

<div *ngIf="!showLoader">
    <ag-grid-angular
            class="ag-theme-bootstrap overnight-table"
            [gridOptions]="gridOptions">
    </ag-grid-angular>
</div>
